import { useEffect, useRef } from 'react'

const useOutsideClickDetectorHook = (when: boolean, callbackFn: () => void) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const clickOutside = (e: MouseEvent) => {
      if (when && ref.current && !ref.current.contains(e.target as Node)) {
        callbackFn()
      }
    }

    document.addEventListener('mousedown', clickOutside)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', clickOutside)
    }
  }, [when, callbackFn])

  return {
    outside_ref: ref,
  }
}

export default useOutsideClickDetectorHook
